import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import {RentalVehicleOrderResponseBody} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

export function useGetActiveRentalOrder(
  activeRentalOrder: RentalVehicleOrderResponseBody | Nullish
) {
  const {data: rentalOrder} = useGetRentalOrderQuery(
    {
      rentalOrderId: activeRentalOrder?.rentalOrderId ?? '',
    },
    {skip: isNilOrEmpty(activeRentalOrder)}
  );

  return rentalOrder ?? null;
}
